import React from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';

import { i18, routerPaths } from '../../utilities';
import { history } from '../../api';
import { ButtonLink, Translate } from '../../components';
import { ResetPasswordForm } from './components';

export const ResetPasswordContainer = () => {
    return (
        <div className='row public_wrapper'>
            <div className='col-12 align-self-center public_content'>
                <div className='public_inner_sm'>
                    <div className='public_title'>
                        <Translate value={i18.Reset.Titles.Reset} />
                    </div>
                    <div className='public_reset_wrapper'>
                        <div className='public_reset_form'>
                            <ResetPasswordForm />
                        </div>
                    </div>
                    <ButtonLink
                        className='p-0'
                        onClick={() => history.replace(routerPaths.login)}
                        icon={<ArrowLeftOutlined />}
                    >
                        <Translate value={i18.Reset.Buttons.Login} />
                    </ButtonLink>
                </div>
            </div>
        </div>
    );
};
